import { Record } from "immutable";

import { syncStatusOptions } from "../../../../constants/syncStatus";
import syncUpdateActions from "../../../../constants/syncUpdateActions";
import createFromJS from "../../../createFromJS";

export const InspectorSyncItemPropertyChangeRecord = Record({
  id: null,
  status: syncStatusOptions.DETECTED_NO_CHANGE,
  action: syncUpdateActions.NONE,
  label: null,
  localValue: null,
  externalValue: null,
  lastSyncValue: null
});

createFromJS.registerCallback(
  "InspectorSyncItemPropertyChangeRecord",
  createFromJS.createPrimitiveCallback(InspectorSyncItemPropertyChangeRecord)
);
